import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
  colors,
  styled,
} from "@mui/material";
//* Helper de confirmacion dialog
import ConfirmationDialog from "../../../helpers/ConfirmationDialog";
//*************** Camera *********************************/
import Camera from "../../../components/camera/camera";
import TextFieldCustom from "../../../helpers/CustomTextFields";
// import imageCompression from "browser-image-compression";
/******************************************************* */
//**************** BD ********************************* */
import bdService from "../../../services/maestros.service";
import bdBodega from "../../../services/bodega.service";
/******************************************************* */
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack"; //Para alertas notificaciones
//****** iconos */
import { useEffect, useState, useRef } from "react";
// import NumFormato from "../../../helpers/numerico";
//***** Iconos
import PostAddIcon from "@mui/icons-material/PostAdd";
import DeleteForeverTwoToneIcon from "@mui/icons-material/DeleteForeverTwoTone";
import DescriptionTwoToneIcon from "@mui/icons-material/DescriptionTwoTone";
import { red } from "@mui/material/colors";
import ImageIcon from "@mui/icons-material/Image";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CheckCircleOutlineTwoToneIcon from "@mui/icons-material/CheckCircleOutlineTwoTone";
import ForwardToInboxTwoToneIcon from "@mui/icons-material/ForwardToInboxTwoTone";
import CancelIcon from "@mui/icons-material/Cancel";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
// import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
// import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
//*********
//**** Camara importación */
import "../../../components/camera/codbarra.css";
import "react-html5-camera-photo/build/css/index.css";
//***** camara */
//************************* */

const DespachosCorreos = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const NumDocRef = useRef(null);
  //******* Variables de Lista  */
  const [items, setItems] = useState([]);
  //****** Variables Camara Foto */
  const [showCamera, setShowCamera] = useState(false);
  const [tipoOperacion, setTipoOperacion] = useState("transferencia");
  const TipoDocTransferencia = ["Guía de Transferencia"];
  const TipoDocVenta = [
    "Factura Afecta",
    "Factura Exenta",
    "Guía de Venta",
    "Boleta de Venta",
  ];
  const TipoDoc =
    tipoOperacion === "transferencia" ? TipoDocTransferencia : TipoDocVenta;
  const [valorSeleccionado, setValorSeleccionado] = useState(TipoDoc[0]);
  const [quiereNavarino, setQuiereNavarino] = useState(false);
  const [tDocCons, setTDocCons] = useState("");
  const [files, setFiles] = useState([]);

  //************************************************* */
  // variables de campo
  //************************************************* */
  const [NomSucOrigen, setNomSucOrigen] = useState("");
  const [IdSucOrigen, setIdSucOrigen] = useState(0);
  const [IdSucDestino, setIdSucDestino] = useState(0);
  const [NomSucDestino, setNomSucDestino] = useState("");
  const [iNumDocumento, setiNumDocumento] = useState(0);
  const [datosConfirmacion, setDatosConfirmacion] = useState(null);
  const [sMsjConf, SetsMsjConf] = useState("");
  const [sMsjObs, SetsMsjObs] = useState("");
  const [correoCliente, setCorreoCliente] = useState("");
  // Estado para almacenar el valor del checkbox
  const [repetirOT, setrepetirOT] = useState(false);
  const [disabledrepetirOT, setdisabledrepetirOT] = useState(false);

  //************* */ Numero de OT Registrado o escrito
  const [DatosG, setDatosG] = useState([]);
  const [iNumOT, setiNumOT] = useState(0);
  const [sNombreTransporte, setsNombreTransporte] = useState("");
  const [Id_Transporte, setId_Transporte] = useState(0);
  //*********************************************** */
  const [bPregTrans, setbPregTrans] = useState(false);
  //***********Mostrar Si necesita Preguntar */
  const [bMostrarTransportista, setbMostrarTransportista] = useState(false);

  //**************************************** */
  // Variables de entorno para mostrar datos
  //**************************************** */
  const [bSucursal, setbSucursal] = useState(false);
  const [bEntradaDoc, setbEntradaDoc] = useState(false);
  const [bAgregarDoc, setbAgregarDoc] = useState(false);
  const [bListaDocEnviar, setbListaDocEnviar] = useState(false);
  const [bBtnTerCan, setbBtnTerCan] = useState(false);
  const [bEnvioEmail, setbEnvioEmail] = useState(false);
  const [bMuestraSuc, setbMuestraSuc] = useState(false);
  const [bListadoImg, setbListadoImg] = useState(false);
  const [bAgregarImg, setbAgregarImg] = useState(false);
  const [openDialogConfirmacion, setOpenDialogConfirmacion] = useState(false);
  // Redux
  //**************************************** */
  const { usuario } = useSelector((state) => state.user);
  // ********************************************************** */
  // ****************** Llenado Sucursal ********************** */
  // ********************************************************** */
  const Limpiar = () => {
    //********** Sucursal ******************************/
    setNomSucOrigen("");
    setIdSucOrigen(0);
    setIdSucDestino(0);
    setNomSucDestino("");
    SetsMsjObs("");
    setbSucursal(false);
    setbEntradaDoc(false);
    setbAgregarDoc(false);
    setbListaDocEnviar(false);
    setbBtnTerCan(false);
    setbEnvioEmail(false);
    setbMuestraSuc(false);
    setbListadoImg(false);
    setbAgregarImg(false);
    setdisabledrepetirOT(false);
    setFiles([]);
    setItems([]);
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    Limpiar();
    CargarSucursal();
    setValorSeleccionado(TipoDoc[0]);
  }, [tipoOperacion]);

  //********************* Cargar Sucursal del usuario */
  const CargarSucursal = async () => {
    setNomSucOrigen(usuario.NomSucursal);
    setIdSucOrigen(usuario.Sucursal);
    setbSucursal(usuario.Sucursal > 0);
    setbEntradaDoc(true);
    setbAgregarDoc(true);
    setTimeout(() => {
      NumDocRef.current.focus();
    }, 200);
  };

  const agregarFoto = (pName, pData, pExt) => {
    // Generar un nuevo objeto con un id único
    // const [files, setFiles] = useState([
    //   { id: 1, name: "Imagen_1", data: "datos", ext: "jpg" },
    //   { id: 2, name: "Imagen_2", data: "datos", ext: "jpg" },
    // ]);
    const nuevaImg = {
      id: Math.random(), // Usamos Math.random() para generar un id único temporalmente
      name: pName,
      data: pData,
      ext: pExt,
    };
    // Actualizar el estado para agregar el nuevo item
    setFiles((prevItems) => [...prevItems, nuevaImg]);
  };

  //*********************************************************** */
  //                      Camara
  //*********************************************************** */
  const handleTakePhoto = async (dataUri) => {
    if (dataUri) {
      try {
        // const blob = await fetch(dataUri).then((res) => res.blob());
        // const compressedImage = await imageCompression(blob, {
        //   maxWidthOrHeight: 1920,
        //   maxSizeMB: 2, // Tamaño de archivo deseado en MB
        //   useWebWorker: true,
        // });
        //setPhoto(compressedImage);
        const ArchivosCantidad = files.length + 1;
        agregarFoto("Imagen_" + ArchivosCantidad, dataUri, "jpg");

        setbListadoImg(true);

        if (tipoOperacion === "transferencia") {
          if (NomSucDestino.length === 0) {
            CargarNomSucursal();
          }
        }

        setbMuestraSuc(true);

        setbEnvioEmail(true);
      } catch (error) {
        enqueueSnackbar(`Error al comprimir la imagen ${error}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
      setShowCamera(false);
    }
  };

  const handleCameraClick = () => {
    //   // Muestra la cámara cuando se hace clic en el botón de la cámara
    setShowCamera(true);
  };

  // const handleOpenDialogConfirmacion = () => {
  //   setOpenDialogConfirmacion(true);
  // };
  const handleCloseDialogConfirmacion = () => {
    setOpenDialogConfirmacion(false);
  };
  const handleNoConfirmacion = () => {
    //handleDeleteDocumentoNumero(iNumDocConfirmacion);
  };
  const handleOpenDialogConfirmacion = (datos) => {
    setDatosConfirmacion(datos);
    setOpenDialogConfirmacion(true);
  };

  const handleSiConfirmacion = async () => {
    if (datosConfirmacion) {
      //*** Agregando el numero de documento */
      const prefijo =
        tDocCons === "D"
          ? "G/."
          : tDocCons === "F"
            ? "F/."
            : tDocCons === "E"
              ? "F.E/."
              : "B/.";
      agregarNumero(
        tipoOperacion === "transferencia" ? "T" : tDocCons,
        datosConfirmacion.Numero,
        datosConfirmacion.Clase,
        `${prefijo}${datosConfirmacion.Numero}-${datosConfirmacion.Clase}`,
        datosConfirmacion.Sucursal,
        datosConfirmacion.Bodega,
        datosConfirmacion.SucDestino,
        datosConfirmacion.BodDestino,
        Id_Transporte,
        sNombreTransporte,
        iNumOT,
        repetirOT,
        datosConfirmacion.IdVendedor,
        datosConfirmacion.IdCliente,
        correoCliente,
      );
      //*** Seteando variables para mostrar listado */
      setbListaDocEnviar(true);
      setbBtnTerCan(true);
      //*** Limpiando variable de numero y posicionando el cursor donde mismo por si desea agregar otro numero */
      setiNumDocumento("");
      setTimeout(() => {
        NumDocRef.current.focus();
      }, 500);
    }
    // ******************************************************** */
  };
  // //******************* Entregado ******************* */
  const handle_GotFocus_Numero = (value) => {
    setiNumDocumento(value.target.value); // formateando el numero para digitar  1.000,6 a 1000.6
  };

  const handle_Change_Numero = (value) => {
    setiNumDocumento(value);
  };

  const handle_KeyDown_Numero = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Evitar que el formulario se envíe automáticamente
      handleAgregarNumeroClick();
    }
  };

  const handle_LostFocus_Numero = (value) => {};

  /***************************************************** */

  const handle_GotFocus_Transporte = (value) => {
    //setiNumDocumento(value.target.value); // formateando el numero para digitar  1.000,6 a 1000.6
  };

  const handle_Change_Transporte = (value) => {
    //setiNumDocumento(value);
    setsNombreTransporte(value);
    // console.log(bPregTrans);
    // if (!bPregTrans) {

    // }
  };

  const handle_KeyDown_Transporte = (event) => {
    if (event.key === "Enter") {
      // event.preventDefault(); // Evitar que el formulario se envíe automáticamente
      // handleAgregarNumeroClick();
      // setTimeout(() => {
      //   NumDocRef.current.focus();
      // }, 200);
    }
  };

  const handle_LostFocus_Transporte = (value) => {};

  /***************************************************** */

  const handle_GotFocus_OT = (value) => {
    //setiNumDocumento(value.target.value); // formateando el numero para digitar  1.000,6 a 1000.6
    setiNumOT(value.target.value); // formateando el numero para digitar  1.000,6 a 1000.6
  };

  const handle_Change_OT = (value) => {
    //setiNumDocumento(value);
    setiNumOT(value);
  };

  const handle_KeyDown_OT = (event) => {
    if (event.key === "Enter") {
      // event.preventDefault(); // Evitar que el formulario se envíe automáticamente
      // handleAgregarNumeroClick();
      // setTimeout(() => {
      //   NumDocRef.current.focus();
      // }, 200);
    }
  };

  const handle_LostFocus_OT = (value) => {};
  //****************************************************** */
  const agregarNumero = (
    tipodoc,
    numero,
    clase,
    descripcion,
    sucorigen,
    bodorigen,
    sucdestino,
    boddestino,
    idtransporte,
    nomtransporte,
    numot,
    repetirot,
    idvendedor,
    idcliente,
    correocliente,
  ) => {
    // Generar un nuevo objeto con un id único
    const nuevoItem = {
      id: Math.random(), // Usamos Math.random() para generar un id único temporalmente
      tipodoc: tipodoc,
      documentNumber: numero,
      clase: clase,
      description: descripcion,
      sucorigen: sucorigen,
      bodorigen: bodorigen,
      sucdestino: sucdestino,
      boddestino: boddestino,
      idtransporte: idtransporte,
      nomtransporte: nomtransporte,
      numot: numot,
      repetirot: repetirot,
      idvendedor: idvendedor,
      idcliente: idcliente,
      correocliente: correocliente,
    };
    // Actualizar el estado para agregar el nuevo item
    setIdSucDestino(sucdestino);
    setItems((prevItems) => [...prevItems, nuevoItem]);
  };

  const vfDespacho = async (sDocRef, iNumero, sClase) => {
    let bPreguntarTransportista;
    let sNombreTransporteResultado;
    let iNumOtTransporteResultado = 0;
    let iIdTransporte = 0;
    let emaildespacho = "";
    const response2 = await bdBodega.dsdesbodegacab(
      -1,
      -1,
      -1,
      sDocRef,
      iNumero,
      sClase,
      "*",
      -1,
      "*",
      -1,
      -1,
      "*",
      "*",
      "P",
    );
    // console.log(response2);
    if (response2.status === 200) {
      const desbodega = response2.data.desbodegacab;
      emaildespacho = desbodega.EmailDes;
      if (repetirOT) {
        if (sNombreTransporte.length === 0) {
          if (desbodega.NomTransporte.length > 0) {
            bPreguntarTransportista = false;
            sNombreTransporteResultado = desbodega.NomTransporte;
            setsNombreTransporte(desbodega.NomTransporte);
            iIdTransporte = desbodega.IdTransporte;
            setId_Transporte(desbodega.IdTransporte);
            if (desbodega.NumTransporte > 0) {
              setiNumOT(Number(desbodega.NumTransporte));
              iNumOtTransporteResultado = desbodega.NumTransporte;
            }
          } else {
            setsNombreTransporte("");
            setId_Transporte(desbodega.IdTransporte);
            iIdTransporte = desbodega.IdTransporte;
            bPreguntarTransportista = true;
          }
        } else {
          bPreguntarTransportista = false;
          sNombreTransporteResultado = sNombreTransporte;
        }
      } else {
        if (desbodega.NomTransporte.length > 0) {
          bPreguntarTransportista = false;
          sNombreTransporteResultado = desbodega.NomTransporte;
          setsNombreTransporte(desbodega.NomTransporte);
          setId_Transporte(desbodega.IdTransporte);
          iIdTransporte = desbodega.IdTransporte;
          if (desbodega.NumTransporte > 0) {
            setiNumOT(Number(desbodega.NumTransporte));
            iNumOtTransporteResultado = desbodega.NumTransporte;
          }
        } else {
          setsNombreTransporte("");
          setId_Transporte(0);
          iIdTransporte = 0;
          bPreguntarTransportista = true;
        }
      }
    } else {
      setsNombreTransporte("");
      setId_Transporte(0);
      iIdTransporte = 0;
      bPreguntarTransportista = true;
    }

    return {
      bPT: bPreguntarTransportista,
      sNT: sNombreTransporteResultado,
      iNOT: iNumOtTransporteResultado,
      iDT: iIdTransporte,
      EmlDes: emaildespacho,
    };
  };

  const handleAgregarNumeroClick = async () => {
    //Revisar numero y indicar si existe el documento en la base de datos
    // Base de datos : D = Exportacion, E =  Exenta,  F = Afecta
    // tipoDocConsulta = "D" =Guia de transferencia, "E" = Factura Exenta, "F" = Factura Afecta, "B" = Boleta de Venta
    try {
      var tipoDocConsulta = "D";
      var sElectronica = "E";
      if (tipoOperacion !== "transferencia") {
        switch (valorSeleccionado) {
          case "Factura Afecta":
            tipoDocConsulta = "F";
            break;
          case "Factura Exenta":
            tipoDocConsulta = "E";
            sElectronica = quiereNavarino ? "N" : "E";
            break;
          case "Guía de Venta":
            tipoDocConsulta = "D";
            break;
          default:
            tipoDocConsulta = "B";
        }
      }

      setTDocCons(tipoDocConsulta);

      const response = await bdService.Get_Documentos(
        tipoDocConsulta,
        IdSucOrigen,
        -1,
        iNumDocumento,
        sElectronica,
      );

      if (response.status === 200) {
        const Datos = response.data.documento[0];
        const DatosLen = response.data.documento;

        if (DatosLen.length > 0) {
          if (
            (Datos.Estado === "S" || Datos.Estado === "N") &&
            Datos.EstadoDte === "G"
          ) {
            // Preguntar si es que ya se digito anteriormente un ot y su transporte, si no tiene que digirar o si copia
            // Contiene datos digitados, ver si tiene ot y transporte
            // Solo Transportista..
            var _bPregTrans;
            var _sNomTrans;
            var _iNumTrans;
            var _idTransporte;
            var _emailDes;

            if (items.length > 0) {
              if (repetirOT) {
                if (sNombreTransporte.length === 0) {
                  const { bPT, sNT, iNOT, iDT, EmlDes } = await vfDespacho(
                    tipoDocConsulta === "D" ? "C" : tipoDocConsulta,
                    Datos.Numero,
                    Datos.Clase,
                  );
                  _bPregTrans = bPT;
                  _sNomTrans = sNT;
                  _iNumTrans = iNOT;
                  _idTransporte = iDT;
                  _emailDes = EmlDes;
                  setCorreoCliente(EmlDes);
                }
              } else {
                const { bPT, sNT, iNOT, iDT, EmlDes } = await vfDespacho(
                  tipoDocConsulta === "D" ? "C" : tipoDocConsulta,
                  Datos.Numero,
                  Datos.Clase,
                );
                _bPregTrans = bPT;
                _sNomTrans = sNT;
                _iNumTrans = iNOT;
                _idTransporte = iDT;
                _emailDes = EmlDes;
                setCorreoCliente(EmlDes);
              }
            } else {
              //**** No tiene ingresado , pero tiene que ver si tiene despacho ingresado el nombre transportista. */
              const { bPT, sNT, iNOT, iDT, EmlDes } = await vfDespacho(
                tipoDocConsulta === "D" ? "C" : tipoDocConsulta,
                Datos.Numero,
                Datos.Clase,
              );
              _bPregTrans = bPT;
              _sNomTrans = sNT;
              _iNumTrans = iNOT;
              _idTransporte = iDT;
              _emailDes = EmlDes;
              setCorreoCliente(EmlDes);
            }
            //************************************************************* */
            console.log(_bPregTrans, _sNomTrans, _iNumTrans, _idTransporte);
            // Hacer algo con PreguntarDespacho, por ejemplo:
            //console.log("¿Preguntar por el despacho?", bPreguntarTransportista);
            //************************************************************* */
            // desabilitando el check de 1 sola OT
            setdisabledrepetirOT(true);
            //************************************************************* */

            if (items.length > 0) {
              if (tipoOperacion === "transferencia") {
                //*** Obteniendo datos de la primera fila */
                const primerItem = items[0];
                const bodegaOrigen = primerItem ? primerItem.bodorigen : null;
                const sucursalDestino = primerItem
                  ? primerItem.sucdestino
                  : null;
                const bodegaDestino = primerItem ? primerItem.boddestino : null;
                //*** Consultando si las sucursales son iguales */
                if (sucursalDestino !== Datos.SucDestino) {
                  enqueueSnackbar(
                    `Solo puede adjuntar documentos de la misma sucursal`,
                    {
                      variant: "info",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    },
                  );
                  return false;
                }
                //*** Consultando si el número existe en la lista */
                const encontrado = items.find(
                  (item) => item.documentNumber === Datos.Numero,
                );
                //*** Si se encontró el número, retorna true; de lo contrario, retorna false */
                if (encontrado !== undefined) {
                  enqueueSnackbar(
                    `El documento ${Datos.Numero} ya se encuentrá ingresado`,
                    {
                      variant: "warning",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    },
                  );
                } else {
                  /*** Consultando si las bodegas de origen son iguales */
                  if (bodegaOrigen !== Datos.Bodega) {
                    SetsMsjConf(
                      "Existen Documentos con diferente bodega de origen, de la misma sucursal ¿Desa continuar?",
                    );
                    handleOpenDialogConfirmacion(Datos);
                  } else {
                    //** Consultando si las bodegas destino son iguales */
                    if (bodegaDestino !== Datos.BodDestino) {
                      SetsMsjConf(
                        "Existen Documentos con diferente bodega de destino, de la misma sucursal ¿Desa continuar?",
                      );
                      handleOpenDialogConfirmacion(Datos);
                    } else {
                      //repetirOT  ' Repetir el numero. y ot
                      setbPregTrans(_bPregTrans);
                      setDatosG([]);
                      setDatosG(Datos); //Copiando datos de la guia para grabar en otro lugar.

                      //Si no se repite se elimina ot de transportista
                      if (!repetirOT) {
                        //Pero si el despacho tiene numero de transporte se lo asigno para que vea si esta bien el numero del sistema.
                        if (_iNumTrans > 0) {
                          setiNumOT(_iNumTrans);
                        } else {
                          setiNumOT(0);
                        }
                      }
                      if (_bPregTrans) {
                        setbMostrarTransportista(true);
                        setbEntradaDoc(false);
                        setbAgregarDoc(false);
                        // se agrega para hacer desaparecer la lista y botones
                        setbListaDocEnviar(false);
                        setbBtnTerCan(false);
                      } else {
                        if (!repetirOT) {
                          setbMostrarTransportista(true);
                          setbEntradaDoc(false);
                          setbAgregarDoc(false);
                          // se agrega para hacer desaparecer la lista y botones
                          setbListaDocEnviar(false);
                          setbBtnTerCan(false);
                        } else {
                          if (sNombreTransporte.length > 0 && iNumOT > 0) {
                            //*** Agregando el 1er numero de documento */
                            // Cuando tiene el valor de transporte si es que busca.
                            const prefijo =
                              tipoDocConsulta === "D"
                                ? "G/."
                                : tipoDocConsulta === "F"
                                  ? "F/."
                                  : tipoDocConsulta === "E"
                                    ? "F.E/."
                                    : "B/.";

                            agregarNumero(
                              tipoOperacion === "transferencia"
                                ? "T"
                                : tipoDocConsulta,
                              Datos.Numero,
                              Datos.Clase,
                              `${prefijo}${Datos.Numero}-${Datos.Clase}`,
                              Datos.Sucursal,
                              Datos.Bodega,
                              Datos.SucDestino,
                              Datos.BodDestino,
                              _idTransporte,
                              sNombreTransporte,
                              iNumOT,
                              repetirOT,
                              Datos.IdVendedor,
                              Datos.IdCliente,
                              _emailDes,
                            );
                            //*** Seteando variables para mostrar listado */
                            setbListaDocEnviar(true);
                            setbBtnTerCan(true);
                            //*** Limpiando variable de numero y posicionando el cursor donde mismo por si desea agregar otro numero */
                            setiNumDocumento("");
                            setTimeout(() => {
                              NumDocRef.current.focus();
                            }, 500);
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                // Cuando tiene datos ingresados en el items
                //****' Documentos de venta'****
                //*** Documentos = transporte */
                //*** Transportistas iguales y clientes =
                //*** vendedores pueden ser distintos, si no tiene despacho no colocar y ser = los sin despacho. */ */
                //*** Consultando si el número existe en la lista */

                var _idCliente = items[0].idcliente; //Cliente Grabado'
                if (_idCliente !== Datos.IdCliente) {
                  enqueueSnackbar(
                    `Solo puede ingresar documentos del mismo cliente`,
                    {
                      variant: "info",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    },
                  );
                  return false;
                }

                const encontrado = items.find(
                  (item) => item.documentNumber === Datos.Numero,
                );
                //*** Si se encontró el número, retorna true; de lo contrario, retorna false */
                if (encontrado !== undefined) {
                  enqueueSnackbar(
                    `El documento ${Datos.Numero} ya se encuentrá ingresado`,
                    {
                      variant: "warning",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    },
                  );
                  return false;
                }

                const TransporteBase = items[0].idtransporte;
                if (TransporteBase !== _idTransporte) {
                  enqueueSnackbar(
                    "Está intentando ingresar un Transporte distinto al ya ingresado. No se pueden mezclar transportistas.",
                    {
                      variant: "warning",
                      anchorOrigin: {
                        vertical: "top",
                        horizontal: "right",
                      },
                    },
                  );
                  return false;
                }

                if (_idTransporte === 0) {
                  const prefijo =
                    tipoDocConsulta === "D"
                      ? "G/."
                      : tipoDocConsulta === "F"
                        ? "F/."
                        : tipoDocConsulta === "E"
                          ? "F.E/."
                          : "B/.";
                  agregarNumero(
                    tipoOperacion === "transferencia" ? "T" : tipoDocConsulta,
                    Datos.Numero,
                    Datos.Clase,
                    `${prefijo}${Datos.Numero}-${Datos.Clase}`,
                    Datos.Sucursal,
                    Datos.Bodega,
                    Datos.SucDestino,
                    Datos.BodDestino,
                    0,
                    "",
                    0,
                    repetirOT,
                    Datos.IdVendedor,
                    Datos.IdCliente,
                    _emailDes,
                  );
                  //*** Seteando variables para mostrar listado */
                  setbListaDocEnviar(true);
                  setbBtnTerCan(true);
                  //*** Limpiando variable de numero y posicionando el cursor donde mismo por si desea agregar otro numero */
                  setiNumDocumento("");
                  setTimeout(() => {
                    NumDocRef.current.focus();
                  }, 500);
                } else {
                  setbPregTrans(_bPregTrans);
                  setDatosG(Datos); //Copiando datos de la guia para grabar en otro lugar.
                  setbMostrarTransportista(true);
                  setbEntradaDoc(false);
                  setbAgregarDoc(false);
                }
              }
            } else {
              //Ingresando el primer documento,
              if (
                (Datos.Estado === "S" || Datos.Estado === "N") &&
                Datos.EstadoDte === "G"
              ) {
                if (tipoOperacion === "transferencia") {
                  setbPregTrans(_bPregTrans);
                  setDatosG(Datos); //Copiando datos de la guia para grabar en otro lugar.
                  if (_bPregTrans) {
                    setbMostrarTransportista(true);
                    setbEntradaDoc(false);
                    setbAgregarDoc(false);
                  } else {
                    setbMostrarTransportista(true);
                    setbEntradaDoc(false);
                    setbAgregarDoc(false);
                  }
                } else {
                  //Ingresar documentos de venta para ignorar el transporte si es que no tiene despacho,
                  //pero si tiene transporte el documento siguiente tiene que tener el mismo transporte.
                  if (_idTransporte === 0) {
                    const prefijo =
                      tipoDocConsulta === "D"
                        ? "G/."
                        : tipoDocConsulta === "F"
                          ? "F/."
                          : tipoDocConsulta === "E"
                            ? "F.E/."
                            : "B/.";
                    agregarNumero(
                      tipoOperacion === "transferencia" ? "T" : tipoDocConsulta,
                      Datos.Numero,
                      Datos.Clase,
                      `${prefijo}${Datos.Numero}-${Datos.Clase}`,
                      Datos.Sucursal,
                      Datos.Bodega,
                      Datos.SucDestino,
                      Datos.BodDestino,
                      0,
                      "",
                      0,
                      repetirOT,
                      Datos.IdVendedor,
                      Datos.IdCliente,
                      _emailDes,
                    );
                    //*** Seteando variables para mostrar listado */
                    setbListaDocEnviar(true);
                    setbBtnTerCan(true);
                    //*** Limpiando variable de numero y posicionando el cursor donde mismo por si desea agregar otro numero */
                    setiNumDocumento("");
                    setTimeout(() => {
                      NumDocRef.current.focus();
                    }, 500);
                  } else {
                    setbPregTrans(_bPregTrans);
                    setDatosG(Datos); //Copiando datos de la guia para grabar en otro lugar.
                    setbMostrarTransportista(true);
                    setbEntradaDoc(false);
                    setbAgregarDoc(false);
                  }
                }
              } else {
                enqueueSnackbar(
                  `Solo puede adjunto documentos enviados y con despacho sin cerrar `,
                  {
                    variant: "warning",
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "right",
                    },
                  },
                );
                setiNumDocumento("");
                setTimeout(() => {
                  NumDocRef.current.focus();
                }, 200);
              }
              //****************************************** */
            }
          } else {
            enqueueSnackbar(
              `Solo puede adjunto documentos enviados y con despacho sin cerrar `,
              {
                variant: "warning",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              },
            );
            setiNumDocumento("");
            setTimeout(() => {
              NumDocRef.current.focus();
            }, 200);
          }
        }
      } else {
        enqueueSnackbar(`Error :  ${response.data.msg}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          allowDownload: true,
          action: (key) => (
            <IconButton onClick={() => closeSnackbar(key)}>
              <CancelIcon />
            </IconButton>
          ),
        });
        setiNumDocumento("");
        setTimeout(() => {
          NumDocRef.current.focus();
        }, 200);
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      console.error(error);
    }
  };
  //**************** Agegar Numero de Guia con Transporte y OT ******************* */
  const handleAceptarOTClick = () => {
    if (sNombreTransporte.length > 0) {
      // console.log("OT", iNumOT);
      // console.log(DatosG);
      if (DatosG.Numero > 0 && iNumOT > 0) {
        //*** Agregando el 1er numero de documento */
        // Cuando tiene el valor de transporte si es que busca.
        const prefijo =
          tDocCons === "D"
            ? "G/."
            : tDocCons === "F"
              ? "F/."
              : tDocCons === "E"
                ? "F.E/."
                : "B/.";
        agregarNumero(
          tipoOperacion === "transferencia" ? "T" : tDocCons,
          DatosG.Numero,
          DatosG.Clase,
          `${prefijo}${DatosG.Numero}-${DatosG.Clase}`,
          DatosG.Sucursal,
          DatosG.Bodega,
          DatosG.SucDestino,
          DatosG.BodDestino,
          Id_Transporte,
          sNombreTransporte,
          iNumOT,
          repetirOT,
          DatosG.IdVendedor,
          DatosG.IdCliente,
          correoCliente,
        );
        //*** Para mostrar Pantalla */
        setbEntradaDoc(true);
        setbAgregarDoc(true);
        //*** Seteando variables para mostrar listado */
        setbListaDocEnviar(true);
        setbBtnTerCan(true);
        //*** Limpiando variable de numero y posicionando el cursor donde mismo por si desea agregar otro numero */
        setiNumDocumento("");
        setbMostrarTransportista(false);
        setTimeout(() => {
          NumDocRef.current.focus();
        }, 500);
      } else {
        enqueueSnackbar(
          `Debe Ingresar Numero de OT y Nombre de Transporte para poder continuar`,
          {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          },
        );
      }
    } else {
      enqueueSnackbar(
        `Debe Ingresar Nombre de Transporte para poder continuar`,
        {
          variant: "warning",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        },
      );
    }
  };
  //**************** Terminar de ingresar documentos ******************* */
  const handleTerminarClick = () => {
    setbEntradaDoc(false);
    setbAgregarDoc(false);
    setbBtnTerCan(false);
    setbAgregarImg(true);
  };
  const handleCancelarCamClick = () => {
    setbEntradaDoc(true);
    setbAgregarDoc(true);
    setbBtnTerCan(true);
    setbAgregarImg(false);
  };
  //**************** Terminar de cancelar el ingreso documentos ******************* */
  const handleCancelarClick = () => {
    //Limpiar los valores Item
    setdisabledrepetirOT(false);
    setiNumOT(0);
    setsNombreTransporte("");
    setiNumDocumento(0);
    setId_Transporte(0);
    setItems([]);
    setbListaDocEnviar(false);
    setbBtnTerCan(false);
    setbAgregarDoc(true);
    setbEntradaDoc(true);
    setbMostrarTransportista(false);
    setTimeout(() => {
      NumDocRef.current.focus();
    }, 200);
  };

  const handleCancelarNumeroClick = () => {
    //Limpiar los valores Item
    if (items.length === 0) {
      setdisabledrepetirOT(false);
      setbListaDocEnviar(false);
      setbBtnTerCan(false);
      setiNumOT(0);
      setsNombreTransporte("");
      setId_Transporte(0);
    } else {
      setbListaDocEnviar(true);
      setbBtnTerCan(true);
    }
    setiNumDocumento(0);
    setbAgregarDoc(true);
    setbEntradaDoc(true);
    setbMostrarTransportista(false);
    //setItems([]);
    setTimeout(() => {
      NumDocRef.current.focus();
    }, 200);
  };

  const handleDelete = (id) => {
    const updatedItems = items.filter((item) => item.id !== id);
    setItems(items.filter((item) => item.id !== id));
    if (updatedItems.length === 0) {
      setiNumDocumento(0);
      setbListaDocEnviar(false);
      setbBtnTerCan(false);
      setbAgregarDoc(true);
      setbEntradaDoc(true);
      setTimeout(() => {
        NumDocRef.current.focus();
      }, 200);
    }
  };

  const handleDeletefile = (id) => {
    setFiles(files.filter((item) => item.id !== id));
  };

  const CargarNomSucursal = async () => {
    try {
      const datos = await bdService.Bodegas(IdSucDestino, "A");
      if (datos.status === 200) {
        setNomSucDestino(datos.data.Sucursales[0].Nombre);
      } else if (datos.status === 400) {
        // Esta mal
      }
    } catch (error) {
      // Manejo del error si ocurre
    }
  };

  const handleEnviarClick = async () => {
    try {
      const EnvioCorreo = await bdService.enviocorreodespacho(
        tipoOperacion === "transferencia" ? "T" : "V",
        usuario.Id,
        IdSucDestino,
        NomSucOrigen,
        NomSucDestino,
        sMsjObs,
        items,
        files,
      );
      if (EnvioCorreo.status === 200) {
        enqueueSnackbar(`Correo enviado`, {
          variant: "success", // Cambiar a "success" para indicar éxito
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });

        setTimeout(() => {
          Limpiar();
          CargarSucursal();
        }, 1000);
      } else if (EnvioCorreo.status === 500) {
        enqueueSnackbar(`Error en datos ${EnvioCorreo.data.message}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    } catch (error) {
      // Manejo del error si ocurre
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  };

  // backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: colors.grey[200],
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.primary.primary,
  }));

  // Controlador de eventos para manejar los cambios en el checkbox
  const handleCheckboxChange = (event) => {
    setrepetirOT(event.target.checked);
  };

  const handleChangeMsj = (event) => {
    SetsMsjObs(event.target.value);
  };

  const manejarCambio = (event) => {
    setValorSeleccionado(event.target.value);
    if (event.target.value !== "Factura Exenta") setQuiereNavarino(false);
  };

  const FileListDoc = ({ archivo }) => {
    return (
      <Grid container spacing={0}>
        {archivo.map((item) => (
          <Grid item xs={12} sm={7} md={7} lg={3} key={item.id}>
            <List>
              <ListItem>
                <ListItemIcon>
                  <DescriptionTwoToneIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={`${item.description}`}
                  secondary={`${item.nomtransporte} OT:${item.numot} `}
                />
                <IconButton onClick={() => handleDelete(item.id)}>
                  <DeleteForeverTwoToneIcon sx={{ color: red[700] }} />
                </IconButton>
              </ListItem>
            </List>
          </Grid>
        ))}
      </Grid>
    );
  };

  const FileListImage = ({ archivo }) => {
    return (
      <Grid container spacing={0}>
        {archivo.map((item) => (
          <Grid item xs={12} sm={7} md={7} lg={3} key={item.id}>
            <List>
              <ListItem>
                <ListItemIcon>
                  <ImageIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={`${item.name}`} />
                <IconButton onClick={() => handleDeletefile(item.id)}>
                  <DeleteForeverTwoToneIcon sx={{ color: red[700] }} />
                </IconButton>
              </ListItem>
            </List>
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <div>
      {showCamera ? (
        <>
          <Camera onTakePhoto={handleTakePhoto} />
          {/* <button onClick={() => setShowCamera(false)}>Cancelar</button> */}
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Grid container justifyContent="center">
              {/* Centra el contenido horizontalmente */}
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  endIcon={<CancelOutlinedIcon />}
                  onClick={() => setShowCamera(false)}
                >
                  Cancelar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          {bSucursal && (
            <Grid item xs={12} sm={12} md={12}>
              <Box
                borderRadius="8px"
                marginTop={1}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  height: "auto",
                  padding: 2, // Añadimos un espacio de relleno al Box
                }}
              >
                {/* "xs" (extra pequeño), "sm" (pequeño), "md" (mediano), "lg" (grande) y "xl" (extra grande) */}
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} p={1}>
                    <Grid container justifyContent="center">
                      {/* Centra el contenido horizontalmente */}
                      <Grid item>Sucursal: {NomSucOrigen}</Grid>
                    </Grid>
                  </Grid>
                  {/* Entrada de Documentos */}
                  {bEntradaDoc && (
                    <>
                      <Grid item xs={12}>
                        <FormControl disabled={items.length > 0}>
                          <RadioGroup
                            row
                            value={tipoOperacion}
                            onChange={(e) => setTipoOperacion(e.target.value)}
                          >
                            <FormControlLabel
                              value="transferencia"
                              control={<Radio />}
                              label="Guía de Transferencia"
                            />
                            <FormControlLabel
                              value="venta"
                              control={<Radio />}
                              label="Venta"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container justifyContent="left">
                          {/* Centra el contenido horizontalmente */}
                          <Grid item>Tipo Documento</Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <Select
                          value={valorSeleccionado}
                          onChange={manejarCambio}
                          // disabled // Deshabilita la capacidad de cambio
                        >
                          {TipoDoc.map((opcion) => (
                            <MenuItem key={opcion} value={opcion}>
                              {opcion}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      {/* Mostrar el check Navarino solo si se selecciona Factura Exenta */}
                      {valorSeleccionado === "Factura Exenta" && (
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={quiereNavarino}
                                onChange={(e) =>
                                  setQuiereNavarino(e.target.checked)
                                }
                                name="navarino"
                                color="primary"
                              />
                            }
                            label="Navarino"
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} sm={12} md={12}>
                        <Grid container justifyContent="left">
                          {/* Centra el contenido horizontalmente */}
                          <Grid item>Número de Documento</Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <TextFieldCustom
                          id="full"
                          inputRef={NumDocRef}
                          label={`Número de Documento`}
                          value={iNumDocumento}
                          TamanioFuente={"12px"}
                          labelStyle={{
                            color: "blue",
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                          inputMode="numeric"
                          maxLength={10}
                          isNumeric={true} // si es numerico
                          decimal={false} // Indica si es decimal
                          decimalCantidad={0} //numero de decima
                          onFocus={handle_GotFocus_Numero} //focus
                          onChange={handle_Change_Numero} //change
                          onBlur={handle_LostFocus_Numero} //al salir foco
                          onKeyDown={handle_KeyDown_Numero} // al soltar un boton
                          sx={{ flexGrow: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={repetirOT}
                              onChange={handleCheckboxChange}
                              disabled={disabledrepetirOT}
                            />
                          }
                          label="Repetir Número OT."
                        />
                      </Grid>
                    </>
                  )}
                  {bAgregarDoc && (
                    <>
                      <Grid item xs={12} sm={12} md={12}></Grid>
                      <Grid item xs={12} sm={12} md={12}></Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Grid container justifyContent="right">
                          {/* Centra el contenido horizontalmente */}
                          <Grid item>
                            <Button
                              variant="contained"
                              endIcon={<PostAddIcon />}
                              onClick={handleAgregarNumeroClick}
                            >
                              Agregar
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  <ConfirmationDialog
                    open={openDialogConfirmacion}
                    onClose={handleCloseDialogConfirmacion}
                    title={sMsjConf}
                    onConfirm={handleSiConfirmacion}
                    onCancel={handleNoConfirmacion}
                  />
                  {bMostrarTransportista && (
                    <>
                      <Grid item xs={12} sm={12} md={12}>
                        <Grid container justifyContent="left">
                          {/* Centra el contenido horizontalmente */}
                          <Grid item>Transportista</Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <TextFieldCustom
                          id="full"
                          // inputRef={NumDocRef}
                          label={`Transportista`}
                          value={sNombreTransporte}
                          disabled={!bPregTrans}
                          TamanioFuente={"12px"}
                          labelStyle={{
                            color: "blue",
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                          inputMode="text"
                          maxLength={50}
                          isNumeric={false} // si es numerico
                          decimal={false} // Indica si es decimal
                          decimalCantidad={0} //numero de decima
                          onFocus={handle_GotFocus_Transporte} //focus
                          onChange={handle_Change_Transporte} //change
                          onBlur={handle_LostFocus_Transporte} //al salir foco
                          onKeyDown={handle_KeyDown_Transporte} // al soltar un boton
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <Grid container justifyContent="left">
                          {/* Centra el contenido horizontalmente */}
                          <Grid item>Número OT</Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <TextFieldCustom
                          id="full"
                          // inputRef={NumDocRef}
                          label={`Número de OT`}
                          value={iNumOT}
                          TamanioFuente={"12px"}
                          labelStyle={{
                            color: "blue",
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                          inputMode="numeric"
                          maxLength={20}
                          isNumeric={true} // si es numerico
                          decimal={false} // Indica si es decimal
                          decimalCantidad={0} //numero de decima
                          onFocus={handle_GotFocus_OT} //focus
                          onChange={handle_Change_OT} //change
                          onBlur={handle_LostFocus_OT} //al salir foco
                          onKeyDown={handle_KeyDown_OT} // al soltar un boton
                          sx={{ flexGrow: 1 }}
                        />
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Button
                          variant="contained"
                          color="success"
                          endIcon={<CheckCircleOutlineTwoToneIcon />}
                          onClick={handleAceptarOTClick}
                        >
                          Aceptar
                        </Button>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Button
                          variant="contained"
                          color="secondary"
                          endIcon={<CancelOutlinedIcon />}
                          onClick={handleCancelarNumeroClick}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                    </>
                  )}

                  {/* Documentos a Enviar  */}
                  {bListaDocEnviar && (
                    <>
                      <Grid item xs={12} md={12}>
                        <Typography
                          sx={{ mt: 4, mb: 2 }}
                          variant="h6"
                          component="div"
                        >
                          Documentos a Enviar
                        </Typography>
                        <FileListDoc archivo={items} />
                      </Grid>
                    </>
                  )}
                  {bBtnTerCan && (
                    <>
                      <Grid item xs={6} md={6}>
                        <Button
                          variant="contained"
                          color="success"
                          endIcon={<CheckCircleOutlineTwoToneIcon />}
                          onClick={handleTerminarClick}
                        >
                          Terminar
                        </Button>
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <Button
                          variant="contained"
                          color="secondary"
                          endIcon={<CancelOutlinedIcon />}
                          onClick={handleCancelarClick}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                    </>
                  )}
                  {/* Agregar Imagenes  */}
                  {bAgregarImg && (
                    <>
                      <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Grid container justifyContent="center">
                          <Button
                            variant="contained"
                            endIcon={<AddAPhotoIcon />}
                            onClick={handleCameraClick}
                          >
                            Agregar Imágenes
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Grid container justifyContent="center">
                          <Button
                            variant="contained"
                            color="secondary"
                            endIcon={<CancelOutlinedIcon />}
                            onClick={handleCancelarCamClick}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {bListadoImg && (
                    <>
                      <Grid item xs={12} md={12}>
                        <Typography
                          sx={{ mt: 4, mb: 2 }}
                          variant="h6"
                          component="div"
                        >
                          Imagenes Adjuntas
                        </Typography>
                        <FileListImage archivo={files} />
                      </Grid>
                    </>
                  )}
                  {bMuestraSuc && (
                    <>
                      <Grid item xs={12} md={12}>
                        <TextField
                          label="Mensaje"
                          multiline
                          placeholder="Si necesita mandar algún mensaje adicional escriba aquí..."
                          rows={4}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          onChange={handleChangeMsj}
                          value={sMsjObs}
                        />
                      </Grid>
                      {tipoOperacion === "transferencia" && (
                        <Grid item xs={12} md={12}>
                          <Stack
                            direction={{ xs: "column", sm: "row" }}
                            spacing={{ xs: 2, sm: 2, md: 2 }}
                          >
                            <Item>Sucursal Origen : {NomSucOrigen} </Item>
                            <Item>Sucursal Destino: {NomSucDestino} </Item>
                          </Stack>
                        </Grid>
                      )}
                      <Grid item xs={12} md={12}></Grid>
                    </>
                  )}
                  {bEnvioEmail && (
                    <>
                      {/***** Si tiene datos de documentos y si tiene fotos adjuntas puedo mostrar el boton de envio. */}
                      {/* Boton Envio  */}
                      <Grid item xs={12} md={12}>
                        <Grid container justifyContent="center">
                          <Button
                            variant="contained"
                            endIcon={<ForwardToInboxTwoToneIcon />}
                            onClick={handleEnviarClick}
                          >
                            Enviar Documentos
                          </Button>
                        </Grid>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Box>
            </Grid>
          )}
        </>
      )}
    </div>
  );
};
export default DespachosCorreos;
